import "core-js";
import "regenerator-runtime/runtime";
import Vue from "vue"
import VueRouter from "vue-router"
import BootstrapVue from "bootstrap-vue"
import VeeValidate from "vee-validate"
import VStepper from "vue-stepper-component"
import vSelect from "vue-select"
import IdleVue from "idle-vue"

// Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core"
import { 
  faFilePdf, 
  faFileExcel, 
  faFileImage, 
  faFileWord, 
  faFilePowerpoint, 
  faFile, 
  faCalendarAlt,
  faEnvelope,
  faArrowAltCircleDown
} from "@fortawesome/free-regular-svg-icons"

import { 
  faBookOpen,
  faInfoCircle,
  faFileInvoiceDollar,
  faHome,
  faPlus,
  faMinus,
  faAngleUp,
  faAngleDown,
  faCaretDown,
  faShareAlt,
  faSync,
  faThList,
  faTimes,
  faExclamationCircle,
  faDownload,
  faSearch,
  faArrowCircleLeft,
  faTruckMoving,
  faFileImport,
  faChevronDown,
  faExpand,
  faExclamationTriangle,
  faPhoneAlt
} from "@fortawesome/free-solid-svg-icons"

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

import App from "@/App.vue"
import store from "@/store"
import router from "@/router"
import "@/filters"

import envSettings from  "@/envSettings.json";

import { globalHelper } from "@/components/mixins/globalHelper"
import { NextivaService } from "@/services/NextivaService"

import lodash, { set } from "lodash"

export const _ = lodash


var env = "";

if(location.host.startsWith('localhost')){
  env = "LOCAL";
}
else if( location.host.includes('-dev.logisnextdealers.com') ){
  env = "DEV";
}
else if( location.host.includes('-qa.logisnextdealers.com') ){
  env = "QA";
}
else {
  env = "PROD";
}

var settings = envSettings[env];

window.appGlobals = {};

if(env == "LOCAL"){
  window.appGlobals.API_URL = settings.API_URL;
}
else{
  window.appGlobals.API_URL = location.origin + settings.API_URL;
}

if(env == "PROD"){
  console.log = function(){};
}

window.appGlobals.SITE_KEY = settings.SITE_KEY;
window.appGlobals.ENABLE_SIGNAL_R = settings.ENABLE_SIGNAL_R;
window.appGlobals.PART_IMAGES_API_URL= settings.PART_IMAGES_API_URL;
window.appGlobals.GLOBAL_LOGIN_MY_PRIVACY= settings.GLOBAL_LOGIN_MY_PRIVACY;
window.appGlobals.GLOBAL_LOGIN_PRIVACY_POLICY_KEY = settings.GLOBAL_LOGIN_PRIVACY_POLICY_KEY;
window.appGlobals.GLOBAL_LOGIN_COOKIE_POLICY_KEY = settings.GLOBAL_LOGIN_COOKIE_POLICY_KEY;
window.appGlobals.GLOBAL_LOGIN_TERMS_AND_CONDITIONS_KEY= settings.GLOBAL_LOGIN_TERMS_AND_CONDITIONS_KEY;
window.appGlobals.GLOBAL_LTS_PORTAL_LINK= settings.GLOBAL_LTS_PORTAL_LINK;

Vue.use(VStepper)
Vue.use(VueRouter)
Vue.use(BootstrapVue)
Vue.use(VeeValidate, {
  inject: true,
  //bootstrap-vue recommends renaming this to avoid naming conflicts
  fieldsBagName: "veeFields"
})

Vue.component("v-select", vSelect);

// Font Awesome
// Add icons to the library
library.add(
  faFilePdf,
  faFileExcel,
  faFileImage,
  faFileWord,
  faFilePowerpoint,
  faFile,
  faShareAlt,
  faBookOpen,
  faFileInvoiceDollar,
  faHome,
  faInfoCircle,
  faPlus,
  faMinus,
  faAngleUp,
  faAngleDown,
  faCaretDown,
  faSync,
  faThList,
  faCalendarAlt,
  faTimes,
  faExclamationCircle,
  faDownload,
  faSearch,
  faArrowCircleLeft,
  faTruckMoving,
  faFileImport,
  faChevronDown,
  faExpand,
  faEnvelope,
  faArrowAltCircleDown,
  faExclamationTriangle,
  faPhoneAlt
)
Vue.component("fa-icon", FontAwesomeIcon)

Vue.mixin({
  methods:  globalHelper.methods
})

NextivaService.SetChatClientVisibility(false);
NextivaService.SetupChatClient();

router.beforeEach((to, from, next) => {
  //appends "#_" to url for when the user clicks a link that goes to the same page they are currently on, so that the components will refresh
  if( to.fullPath === from.fullPath ){
    next({path: to.fullPath + "#_"});
  }
  else if(to.fullPath.includes(".aspx")){
    next({path: to.fullPath.replace(".aspx", "") });
  }
  else{
    next();
  }
});

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime:  60000/*minute */ * 90 /* number of minutes */, 
  startAtIdle: false
});
// eslint-disable-next-line no-new
new Vue({
  router: router,
  el: "#app",
  store,
  mounted () {
      this.$el.addEventListener("dragover", this.stopDefaultDragAndDrop);
      this.$el.addEventListener("drop", this.stopDefaultDragAndDrop);
  },
  methods: {
    stopDefaultDragAndDrop (e) {
      if (e.target.id !== "fileUploadInput") {
        e.preventDefault();
      }
    },
  },
  render: h => h(App)
})
